import UploadCloudIcon from '../../assets/icons/UploadCloudIcon.svg?react';
import { cn } from '../../utils/classNames';
import {
  EASY_MODE_ACCEPTED_EXTENSIONS,
  EASY_MODE_DROPZONE_DOCUMENT_TYPES
} from '../../constants/easyModeDocuments';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import XFileUpload from '../common/XFileUpload';
import TooltipWrapper from '../ui-control/TooltipWrapper';
import {
  dropzoneActiveClasses,
  dropzoneButtonClasses,
  dropzoneButtonRowClasses,
  dropzoneClasses,
  dropzoneDividerClasses,
  dropzoneDividerLabelClasses,
  dropzoneDividerLineClasses,
  dropzoneErrorListClasses,
  dropzoneIconClasses,
  dropzoneListClasses,
  dropzoneTitleClasses
} from './easyModeClasses';

const ACCEPT_ATTRIBUTE = EASY_MODE_ACCEPTED_EXTENSIONS.join(',');

const EasyModeDropzone = ({
  isDragActive,
  rejections,
  fileInputRef,
  folderInputRef,
  dragHandlers,
  cloudSources,
  onBrowseFiles,
  onBrowseFolder,
  onFilesSelected
}) => (
  // the whole panel is the drop target, button row included
  <div
    className={cn(dropzoneClasses, isDragActive && dropzoneActiveClasses)}
    data-tour={TOUR_TARGETS.EASY_MODE_DROPZONE}
    {...dragHandlers}
  >
    <UploadCloudIcon className={dropzoneIconClasses} />
    <p className={dropzoneTitleClasses}>Drop all your case documents - I&apos;ll sort them</p>
    <ul className={dropzoneListClasses}>
      {EASY_MODE_DROPZONE_DOCUMENT_TYPES.map((documentType) => (
        <li key={documentType}>{documentType}</li>
      ))}
    </ul>

    <div className={dropzoneDividerClasses}>
      <span className={dropzoneDividerLineClasses} />
      <span className={dropzoneDividerLabelClasses}>Or import from</span>
      <span className={dropzoneDividerLineClasses} />
    </div>

    <div className={dropzoneButtonRowClasses}>
      <button type="button" className={dropzoneButtonClasses} onClick={onBrowseFiles}>
        Browse files
      </button>
      <button type="button" className={dropzoneButtonClasses} onClick={onBrowseFolder}>
        Browse folder
      </button>
      {cloudSources.map(
        ({ value, label, iconClasses, isAvailable, isDisabled, unavailableReason, onClick }) => (
          <TooltipWrapper
            key={value}
            showTooltip={!isAvailable}
            title={unavailableReason}
            variant="info"
          >
            <span>
              <button
                type="button"
                className={cn(dropzoneButtonClasses, 'w-full')}
                disabled={isDisabled}
                onClick={onClick}
              >
                <i className={iconClasses} />
                {label}
              </button>
            </span>
          </TooltipWrapper>
        )
      )}
    </div>

    {/* filterAcceptedFiles owns the checks, so XFileUpload's PDF-centric validation stays off */}
    <XFileUpload
      ref={fileInputRef}
      multiple
      shouldValidate={false}
      accept={ACCEPT_ATTRIBUTE}
      className="hidden"
      onFileSelect={onFilesSelected}
    />

    {/* null rather than undefined, or the accept default lands a PDF filter on the folder picker */}
    <XFileUpload
      ref={folderInputRef}
      multiple
      shouldValidate={false}
      accept={null}
      webkitdirectory=""
      directory=""
      className="hidden"
      onFileSelect={onFilesSelected}
    />

    {rejections.length > 0 && (
      <ul className={dropzoneErrorListClasses}>
        {rejections.map(({ fileName, reason }) => (
          <li key={`${fileName}-${reason}`}>{`${fileName} - ${reason}`}</li>
        ))}
      </ul>
    )}
  </div>
);

export default EasyModeDropzone;
